module.exports = __webpack_public_path__ + "static/media/blande.ae898389.mp3";